module.exports = __webpack_public_path__ + "media/images/client_logos/logo_kantar_tns_200-2297b9fa7ad4518b357ee72c2ee1b3cf.png";